import { Button } from "@/components/ui/button";
import { Play, RefreshCw } from "lucide-react";

type ResetButtonProps = {
  onReset: () => void;
  isLoading?: boolean;
  canReset?: boolean;
  isMobile?: boolean;
  isPublic?: boolean;
  isInline?: boolean;
  hideHeader?: boolean;
  brandColor?: string;
};

export const ResetButton = ({
  onReset,
  isLoading = false,
  canReset = true,
  isMobile,
  isPublic,
  isInline,
  hideHeader,
  brandColor
}: ResetButtonProps) => {
  if (!canReset || hideHeader) return null;

  // For public chats, we don't render here as the reset button is now in the ChatInput
  if (isPublic) return null;

  if (isInline) {
    return (
      <div className="p-4 bg-white">
        <Button
          className="w-full"
          onClick={onReset}
          disabled={isLoading}
          style={brandColor ? { backgroundColor: brandColor } : undefined}
        >
          <Play className="h-4 w-4 mr-2" />
          Reset Conversation
        </Button>
      </div>
    );
  }

  // Default floating button style
  return (
    <div className="absolute right-4 bottom-20 z-10">
      <Button
        variant="outline"
        size="icon"
        onClick={onReset}
        disabled={isLoading}
        className="h-12 w-12 rounded-full border border-gray-200 bg-white shadow-sm"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        title="Reset conversation"
      >
        <RefreshCw size={18} />
      </Button>
    </div>
  );
};